const apiUrl = process.env.REACT_APP_API_URL;

export const GetJutgeProblemesIdAlumnes = async (idProblem: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/problemes/${idProblem}/alumnes`);
        if (!response.ok) return [];
        return await response.json();
    } catch (error) {
        console.log('Error al obtener los datos:', error);
        return [];
    }
};
